
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/themes",
      function () {
        return require("private-next-pages/sa/themes.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/themes"])
      });
    }
  